import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../../capabilities';
import { NOTIFICATIONS_SIDEBAR_COMPONENT } from '../../constants';
import { Channels } from '../constants';
import { getPath, getQueryParams, getSidebarStyle, onNewNotification, onPrimaryTabChange, onScreenSizeChange, onSidebarOpen, onMeetingLinkEmptyStateEligibilityResponse, onInviteEmptyStateEligibilityResponse, onSalesExtensionEmptyStateEligibilityResponse } from '../internal';
import { args } from '../../../common/args';
const NAVIGATION_SIDEBAR_IFRAME_ID = 'in-app-notifications-sidebar-iframe';
export const sidebarNotificationsComponentDef = defineComponent(NOTIFICATIONS_SIDEBAR_COMPONENT, () => {
  const forceOpen = new URLSearchParams(window.location.search).get('openSidebar') === 'true';
  return {
    name: NOTIFICATIONS_SIDEBAR_COMPONENT,
    path: getPath({
      channel: Channels.SIDEBAR
    }),
    queryParams: getQueryParams(),
    propsSchema: {
      initialFilter: args.optional(args.string())
    },
    initialProps: {},
    iframeProps: {
      id: NAVIGATION_SIDEBAR_IFRAME_ID,
      style: getSidebarStyle()
    },
    functions: Object.assign({}, onNewNotification, onPrimaryTabChange, onSidebarOpen, onScreenSizeChange, onMeetingLinkEmptyStateEligibilityResponse, onInviteEmptyStateEligibilityResponse, onSalesExtensionEmptyStateEligibilityResponse),
    scrolling: false,
    initiallyOpen: forceOpen,
    deferLoading: !forceOpen,
    capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName(), capabilities.RELOAD_PAGE_CAP.getName(), capabilities.TOGGLE_NOTIFICATION_SIDEBAR_CAP.getName(), capabilities.UPDATE_BELL_ICON_COUNT_CAP.getName()]
  };
});